import React, {Fragment} from 'react';
import Navibar from './layout/Navbar';
import Home from './layout/Home/Home';
import About from './layout/AboutUs/About'
import Footer from './layout/Footer';
import TechnologyStack from './layout/TechnologyStack/TechnologyStack';
import Services from './layout/Services/Services';
import Industries from './layout/Industries/Industries';
import ContactUs from './layout/ContactUs/ContactUs';
import DigitalInnovationLab from './layout/Services/DigitalInnovationLab';
import SoftwareDevelopment from './layout/Services/SoftwareDevelopment';
import MobileApp from './layout/Services/MobileApp';
import Ecommerce from './layout/Services/Ecommerce';
import Iot from './layout/Services/Iot';
import Blockchain from './layout/Services/Blockchain';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import ScrollToTop from './Scroll';




function App() {

  
  return (

    
    <div>
  <Router >
    <ScrollToTop>
   
      <Navibar />

      <Switch>
        <Route exact path='/' component={Home} />
        <Route path='/About' component={About} />
        <Route path='/Services' component={Services} />
        <Route path='/Industries' component={Industries} />
        <Route path='/TechnologyStack' component={TechnologyStack} />
        <Route path='/ContactUs' component={ContactUs} />
        <Route path='/DigitalInnovationLab' component={DigitalInnovationLab} />
        <Route path='/SoftwareDevelopment' component={SoftwareDevelopment} />
        <Route path='/MobileApp' component={MobileApp} />
        <Route path='/Ecommerce' component={Ecommerce} />
        <Route path='/Iot' component={Iot} />
        <Route path='/Blockchain' component={Blockchain} />
      </Switch>

      <Footer />
      </ScrollToTop>
  </Router>

  

</div>
  );
}

export default App;
